<template>
  <div>
    <!-- Print Button -->
    <button class="print-btn" @click="printCertificate">
      <img src="assets/printer.svg" alt="Printer Icon">
    </button>

    <page size="A4" class="certificate-page" :style="{ 'background-image': 'url(' + county.bgLink + ')' }">

      <!-- Watermark -->
      <div class="watermark-text">{{ certificate.billNo || '' }}</div>

      <!-- Header -->
      <header class="certificate-header">
        <div class="logo-left">
          <img :src="county.stateLogo" alt="Coat of Arms">
        </div>
        <div class="header-center">
          <h2 class="county-title">COUNTY GOVERNMENT OF {{ county.countyName }}</h2>
          <h4 class="sub-county-title">{{ certificate.subCountyName || 'SUB COUNTY' }}</h4>
          <p class="contact-info">
            {{ county.address || '' + county.countyName }}<br>
            Email: {{ county.email || '' + (county.countyName ? county.countyName.toLowerCase() : '') + '' }}
          </p>
        </div>
        <div class="logo-right">
          <img :src="county.logo" alt="County Logo">
        </div>
      </header>

      <!-- Department Title -->
      <div class="department-section">
        <p class="department-title">
          DEPARTMENT OF LANDS, PHYSICAL PLANNING,<br>
          URBAN DEVELOPMENT, HOUSING AND MUNICIPALITIES
        </p>
      </div>

      <!-- Certificate Title -->
      <div class="title-section">
        <h1 class="certificate-title">Clearance Certificate</h1>
      </div>

      <!-- Certification Text -->
      <div class="certification-section">
        <p class="certification-text">
          This is to certify that Rates/Rent due to the <strong>COUNTY GOVERNMENT OF {{ county.countyName }}</strong> in respect of Plot No:
          <strong>{{ certificate.LRNumber}}</strong>, registered in the name of
          <strong>{{ certificate.ownerNames ? certificate.ownerNames.toUpperCase() : 'N/A' }}</strong>
          ({{ certificate.ownerID || '' }}) has been paid to the said
          <strong>COUNTY GOVERNMENT OF {{ county.countyName }}</strong>
        </p>
      </div>

      <!-- Ornament -->
      <div class="ornament-section">
        <img src="./assets/ornament.svg" alt="Ornament" class="ornament">
      </div>

      <!-- Details Table -->
      <div class="table-section">
        <table class="details-table">
          <tr>
            <td class="cell-applicant">
              <span class="label">Applicants Name</span><br>
              <span class="value">{{ certificate.ownerNames || 'N/A' }}</span>
            </td>
            <td class="cell-date">
              <span class="label">Date</span><br>
              <span class="value">{{ formatDateTime(certificate.approvedDate || certificate.dateCreated) }}</span>
            </td>
            <td class="cell-served">
              <span class="label">Served By</span><br>
              <span class="value">{{ certificate.names }}</span>
            </td>
            <td class="cell-qr">
              <img :src="qrCodeUrl" alt="QR Code" class="qr-code">
            </td>
          </tr>
        </table>
      </div>

      <!-- Signature Section -->
      <div class="signature-section">
        <div class="signature-left">
          <p class="sig-date">DATE: {{ formatDateUpper(certificate.approvedDate) }}</p>
          <div class="sig-line"></div>
          <p class="sig-label">DATE APPROVED</p>
        </div>

        <div class="signature-center">
          <img :src="county.sealLand" alt="Official Seal" class="seal-image">
        </div>


        <div class="signature-right">
          <img v-if="certificate.signature" :src="getSignatureUrl()" alt="Signature" class="signature-img">
          <div class="sig-line"></div>
          <p class="sig-label">{{ getApproverName(certificate.approvedBy).toUpperCase() }}</p>
        </div>
      </div>

      <!-- Footer -->
      <div class="footer-section">
        <div class="serial-row">
          <span>Serial No.: <span class="serial-number">{{ certificateSerial }}</span></span>
          <span>Date Downloaded {{ currentDateTime }}</span>
        </div>
        <div class="green-line"></div>
        <p class="county-footer">COUNTY GOVERNMENT OF {{ county.countyName }}</p>
      </div>

    </page>
  </div>
</template>

<script>
/* eslint-disable */
import { execute, landRate, signatureBaseURl } from "@/api";
import moment from "moment";

export default {
  name: "ClearanceCertificatePrint",
  data() {
    return {
      loading: true,
      certificate: {},
      county: {
        countyName: '',
        logo: '',
        stateLogo: '',
        seal: '',
        signature: '',
        signatureName: '',
        bgLink: '',
        address: '',
        email: '',
        QRLink: ''
      },
      qrCodeUrl: 'assets/code-demo.png'
    }
  },
  computed: {
    certificateSerial() {
      if (!this.certificate || !this.certificate.id) return 'CLRNC_CERT1';
      return `CLRNC_CERT${this.certificate.id}`;
    },
    currentDateTime() {
      return moment().format('DD MMM YYYY h:mm A');
    }
  },
  mounted() {
    this.loadParams();
  },
  methods: {
    loadParams() {
      try {
        const params = JSON.parse(localStorage.getItem('params'));
        if (params) {
          this.getCertificateDetails(params.certificateId, params.billNo);
        } else {
          this.loading = false;
        }
      } catch (e) {
        console.error('Error loading params:', e);
        this.loading = false;
      }
    },

    getCertificateDetails(certificateId, billNo) {
      const data = new FormData();
      data.append("function", "getClearanceCertificateById");
      data.append("id", certificateId || '');
      data.append("billNo", billNo || '');

      execute(data, landRate)
          .then((res) => {
            this.loading = false;
            if (res.data.success) {
              this.certificate = res.data.data.certificate;
              this.county = res.data.data.county;
              this.generateQRCode();
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
          });
    },

    getPlotNo() {

      return
          this.certificate.plotNo ||
          this.certificate.LRNumber ||
          'N/A';
    },


    generateQRCode() {
      const qrBase = this.county.QRLink || 'https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=';
      const qrData = `Bill No: ${this.certificate.billNo} | ${this.certificate.names} | ${this.getPlotNo()}`;
      this.qrCodeUrl = qrBase + encodeURIComponent(qrData);
    },

    formatDate(date) {
      if (!date) return moment().format('DD MMM YYYY');
      return moment(date).format('DD MMM YYYY');
    },

    formatDateUpper(date) {
      if (!date) return moment().format('DD MMM YYYY').toUpperCase();
      return moment(date).format('DD MMM YYYY').toUpperCase();
    },

    formatDateTime(date) {
      if (!date) return moment().format('DD MMM YYYY h:mm A');
      return moment(date).format('DD MMM YYYY h:mm A');
    },

    getApproverName(approvedBy) {
      if (!approvedBy) return 'Authorized Officer';
      const match = approvedBy.match(/^([^(]+)/);
      return match ? match[1].trim() : approvedBy;
    },

    getSignatureUrl() {
      if (!this.certificate.signature) return '';
      return signatureBaseURl + this.certificate.signature;
    },

    printCertificate() {
      window.print();
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Pridi:wght@200;300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Fondamento:ital@0;1&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');

* {
  box-sizing: border-box;
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;
}

.print-btn {
  position: fixed;
  top: 30px;
  right: 30px;
  z-index: 10000;
  background: #215939;
  color: white;
  border-radius: 50%;
  padding: 1rem;
  border: none;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0,0,0,0.3);
  transition: 0.3s;
}

.print-btn:hover {
  background: #1a4a2e;
  transform: scale(1.1);
}

.print-btn img {
  height: 35px;
  width: 35px;
}

/* Page Setup */
page {
  display: block;
  width: 210mm;
  height: 297mm;
  margin: 0 auto;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  box-shadow: 0 0 15px rgba(0,0,0,0.3);
  position: relative;
  overflow: hidden;
}

.certificate-page {
  padding: 10mm 15mm;
  display: flex;
  flex-direction: column;
}

/* Watermark */
.watermark-text {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(45deg);
  font-size: 100px;
  font-weight: 700;
  color: rgba(0, 128, 0, 0.08);
  font-family: 'Pridi', serif;
  pointer-events: none;
  white-space: nowrap;
  text-transform: uppercase;
}

/* Header */
.certificate-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5mm 0;
  margin-bottom: 5mm;
}

.logo-left img,
.logo-right img {
  height: 30mm;
  width: auto;
}

.header-center {
  text-align: center;
  flex: 1;
  padding: 0 10mm;
}

.county-title {
  color: #00582f;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 2mm 0;
  text-transform: uppercase;
}

.sub-county-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 3mm 0;
  text-transform: uppercase;
}

.contact-info {
  font-size: 12px;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
}

/* Department */
.department-section {
  text-align: center;
  margin: 8mm 0;
}

.department-title {
  font-size: 13px;
  font-weight: 400;
  font-family: 'Pridi', serif;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0;
  line-height: 1.5;
}

/* Certificate Title */
.title-section {
  text-align: center;
  margin: 8mm 0;
}

.certificate-title {
  font-family: 'Fondamento', cursive;
  font-size: 50px;
  font-weight: 400;
  margin: 0;
  color: #000;
}

/* Certification Text */
.certification-section {
  text-align: center;
  margin: 8mm 0;
  padding: 0 10mm;
}

.certification-text {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
  margin: 0;
}

/* Ornament */
.ornament-section {
  text-align: center;
  margin: 5mm 0;
}

.ornament {
  width: 140px;
  height: auto;
}

/* Table */
.table-section {
  margin: 8mm 0;
  padding: 0 5mm;
}

.details-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #000;
}

.details-table td {
  border: 1px solid #000;
  padding: 8px 10px;
  vertical-align: top;
  font-size: 12px;
}

.cell-applicant {
  width: 30%;
}

.cell-date {
  width: 25%;
}

.cell-served {
  width: 25%;
}

.cell-qr {
  width: 20%;
  text-align: center;
  vertical-align: middle !important;
}

.label {
  color: #00582f;
  font-family: 'Open Sans', sans-serif;
  font-size: 11px;
  font-weight: 600;
}

.value {
  font-family: 'Pridi', serif;
  font-size: 12px;
  font-weight: 400;
}

.qr-code {
  width: 70px;
  height: 70px;
}

/* Signature Section */
.signature-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin: 15mm 0 10mm 0;
  padding: 0 15mm;
}

.signature-left,
.signature-right {
  text-align: center;
  width: 50mm;
}

.signature-center {
  text-align: center;
}

.sig-date,
.sig-name {
  font-size: 10px;
  text-transform: uppercase;
  margin: 0 0 3mm 0;
}

.sig-line {
  width: 50mm;
  height: 0;
  border-bottom: 1px solid #000;
  margin: 0 auto 2mm auto;
}

.sig-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
}

.seal-image {
  height: 100px;
  width: auto;
}

.signature-img {
  height: 40px;
  width: auto;
  margin-bottom: 2mm;
}

/* Footer */
.footer-section {
  margin-top: auto;
  padding: 0 5mm;
}

.serial-row {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  font-weight: 500;
  margin-bottom: 2mm;
}

.serial-number {
  color: red;
  font-weight: 700;
}

.green-line {
  height: 3px;
  background: linear-gradient(to right, #00582f, #4CAF50, #00582f);
  margin-bottom: 2mm;
}

.county-footer {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0;
}

/* Print Styles */
@media print {
  body {
    margin: 0;
    padding: 0;
    background: white;
  }

  .print-btn {
    display: none !important;
  }

  page {
    margin: 0;
    box-shadow: none;
    width: 210mm;
    height: 297mm;
  }

  @page {
    size: A4 portrait;
    margin: 0;
  }
}

/* Screen background */
@media screen {
  body {
    background: #ccc;
    margin: 20px;
  }
}
</style>